<template>
<div class="col-12 text-left">
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">NCR Action Answer Form</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-2">
                <label for="module">Complaint Number</label>
                <input type="text" class="form-control" id="complaintNo" v-model="nc.ncrNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Action Number</label>
                <input type="text" class="form-control" id="complaintNo" v-model="nc.actionNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Target Date</label>
                <flat-pickr class="form-control" v-model="nc.targetDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-2">
                <label >Root Cause Type</label>
                <input type="text" class="form-control" id="complaintNo" v-model="nc.rootCauseType" disabled>
            </div>
            <div class="form-group col-2">
                <label >Action Type</label>
                <input type="text" class="form-control" id="complaintNo" v-model="nc.actionType" disabled>
            </div>
            
            <!-- <div v-if="nc.type === 'corrective'" class="form-group col-6">
                <label for="module">Corrective</label>
                <input type="text" class="form-control" id="complaintNo" v-model="nc.corrective" disabled>
            </div>
            <div v-if="nc.type === 'preventive'" class="form-group col-6">
                <label for="module">Preventive</label>
                <input type="text" class="form-control" id="complaintNo" v-model="nc.preventive" disabled>
            </div> -->
        </div>
        <div class="row">
            <div v-if="this.nc.item" class="form-group col-6">
                <label for="module">Item to be revised</label>
                <textarea class="form-control" id="desc-textarea" v-model="nc.item" rows="2" disabled></textarea>
            </div>
            <div v-if="this.nc.remark" class="form-group col-6">
                <label for="module">Comment</label>
               <textarea class="form-control" id="desc-textarea" v-model="nc.remark" rows="2" disabled></textarea>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label for="module">Root Cause Remark</label>
                <textarea class="form-control" id="desc-textarea" v-model="nc.rootCauseRemark" rows="3" disabled></textarea>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label for="module">Action Remark</label>
                <textarea class="form-control" id="desc-textarea" v-model="nc.actionRemark" rows="3" disabled></textarea>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
                <label for="module">Work Description</label>
                <textarea class="form-control" id="desc-textarea" v-model="nc.workDescription" rows="2"></textarea>
            </div>
            <div class="form-group col-6">
                <label for="module">Please Submit your Investigation</label>
               <app-uploader :fileUrl="nc.evidence" :fieldName="'evidence'" v-on:finishUpload="finishUpload(...arguments)"></app-uploader>
            </div>
        </div>
        <!-- <button type="button" class="btn btn-outline-success" @click="previewcparcc">Print CPAR-CC <i class="fas fa-print"></i></button> -->
        <!-- <button type="button" class="btn btn-outline-success" @click="previewccf">Print CCF <i class="fas fa-print"></i></button> -->
        <br /><br />
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-warning" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { ncrCorrective } from '../../models/ncrCorrective'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppUploader from '../../components/AppUploader.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar, AppDropdown, AppDatatable, AppUploader
    },
    data() {
        return {
            nc: {...ncrCorrective},
        }
    },
    async created() {
        const isLogin = localStorage.getItem('ucf_token')
        if(isLogin) {
            if(this.$route.query.id !== undefined) {
            const query = {
                params: {
                    id: this.$route.query.id,
                    type: this.$route.query.type,
                    isRevision: this.$route.query.isrevision,
                }
            }
            const ncApi = api('ncr-corrective-answer')
            this.nc = await ncApi.getWithQuery(query)
            // this.nc.customerComplaintCorrectiveDetail.isRevision = this.$route.query.isrevision
            console.log(this.nc)
        }
        } else {
            this.$router.push({ name: 'login' })
        }
    },
    methods: {
        async save() {
            if(!this.$route.query.isrevision) {
                const ncApi = api('ncr-corrective-answer')
                await ncApi.update(this.nc, this.$route.query.id)
            } else {
                const ncApi = api('ncr-corrective-answer-revision')
                await ncApi.update(this.nc, this.$route.query.id)
            }
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        cancel() {
            // this.$router.go(-1)
        },
        previewcparcc() {
            if(this.selectedId !== '') {
                this.$router.push({
                    name: 'cpar-cc',
                    query: {
                        id: this.nc.customerComplaintId
                    }
                })
            }
        },
        previewccf() {
            if(this.selectedId !== '') {
                this.$router.push({
                    name: 'ccf',
                    query: {
                        id: this.nc.customerComplaintId
                    }
                })
            }
        },
        finishLookup(data) {
            const currentnc = this.nc
            this.nc = {
                ...currentnc,
                ...data
            }
        },
        finishUpload(data) {
            const currentnc = this.nc
            this.nc = {
                ...currentnc,
                ...data
            }
        },
    }
}
</script>